import { FC, MouseEvent } from 'react';
import {
	Box,
	BoxProps,
	FormHelperText,
	IconButton,
	MenuItem,
	Select,
	SelectProps,
	Tooltip,
	TypographyProps
} from '@mui/material';
import { StyledInputLabel } from '../AMBGTextField/AMBGTextField.style';
import { IDropDownOption } from 'shared/interface';
import { InfoOutlined as InfoOutlinedIcon } from '@mui/icons-material';
import * as Sx from 'assets/styles/Common.style';
interface IProps {
	label: string;
	menuItem: IDropDownOption[];
	boxProps?: BoxProps;
	labelProps?: TypographyProps;
	helperText?: string | undefined;
	placeholder?: string;
	infoIconText?: string;
	infoIconOnclick?: (event: MouseEvent<HTMLButtonElement>) => void;
}

const AMBGSelect: FC<IProps & SelectProps> = (props) => {
	const { label, boxProps, helperText, labelProps, menuItem, placeholder, infoIconOnclick, ...rest } = props;
	return (
		<Box width='100%' {...boxProps}>
			<StyledInputLabel {...labelProps}>{label}</StyledInputLabel>
			<Box sx={{ display: 'flex', alignItems: 'center' }}>
				<Select
					fullWidth
					size='small'
					labelId='labelID'
					id='demo-simple-select-helper'
					sx={{
						'&.MuiInputBase-sizeSmall': {
							'.MuiInputBase-input': {
								paddingTop: '11.5px',
								paddingBottom: '11.5px'
							}
						},
						fontSize: '12px',
						borderRadius: '24px',
						'& .MuiSelect-select': placeholder && {
							'.notranslate::after': {
								content: `"${placeholder}"`,
								opacity: 0.42
							}
						}
					}}
					data-testid='select'
					{...rest}
				>
					{menuItem?.map((menu) => (
						<MenuItem
							data-testid='select-option'
							value={menu.value as keyof IDropDownOption}
							key={`${menu.label}_title`}
							sx={{ fontSize: '12px' }}
						>
							{menu.label}
						</MenuItem>
					))}
				</Select>
				{infoIconOnclick && (
					<IconButton
						data-testid='iconButton'
						disableRipple
						sx={Sx.iconButton}
						onClick={(event) => infoIconOnclick(event)}
					>
						<Tooltip title='Role Information' arrow data-testid='info-tooltip'>
							<InfoOutlinedIcon />
						</Tooltip>
					</IconButton>
				)}
			</Box>
			{helperText && <FormHelperText sx={{ color: '#d32f2f', paddingLeft: '14px' }}>{helperText}</FormHelperText>}
		</Box>
	);
};

export default AMBGSelect;
